export default __webpack_public_path__ + "img/80077496588589abbe829eee10cf8596.png";